import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Navbar from "./Components/Navbar"; // Assuming your Navbar component is in this path
import { storeBrowserUUID } from "./utils/UTILITY_METHODS";

function App() {
  const userDetails = useSelector((store) => store.userDetails);
  useEffect(() => {
    storeBrowserUUID();
  }, []);

  return (
    <div className="min-h-[100vh] font-inter  bg-white bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px]">
      {/* Navbar - Ensure it stays fixed at the top */}
      <Navbar
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 9999,
          backgroundColor: "#fff",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        }}
      />

      <div style={{ paddingTop: "70px", paddingRight: "10px" }}>
        <Outlet />
      </div>
    </div>
  );
}

export default App;
